import { render, staticRenderFns } from "./LiabilityOtherEstatePlanning.vue?vue&type=template&id=9408bc5a"
import script from "./LiabilityOtherEstatePlanning.vue?vue&type=script&lang=js"
export * from "./LiabilityOtherEstatePlanning.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports